import { createAction } from 'redux-starter-kit';
import { push } from 'connected-react-router'
import { post } from '../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../domain/requests/RequestActions';
import { addNotification } from '../application/messageUiActions';

/**
 * An action that signifies a request for support
 */
export const submitSupportTicket = createAction('SUBMIT_SUPPORT_TICKET');

/**
 * A action creator that submits a support request.
 * @param {object} supportTicket The Support ticket to submitted
 */
export function requestSubmitSupportTicket(supportTicket) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(submitSupportTicket.toString()));
    dispatch(submitSupportTicket({ requestId }));
    try {
      const ticketId = await post('/api/contact-us', { }, supportTicket);

      // Set the ticket Id as teh request payload so we can display it on screen.
      dispatch(requestSucceded(requestId, ticketId));
      dispatch(addNotification('success', null, supportTicket.ticketType, {}, 'supportTicketSuccess', { ticketId }));
      dispatch(push('/dashboard'));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}
